module.exports = __webpack_public_path__ + "static/media/left.10a4e098.svg";